"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealSandwichTwoFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealSandwichTwoFilled = function MealSandwichTwoFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 33h22.586c.89 0 1.337-1.077.707-1.707L9.707 8.707C9.077 8.077 8 8.523 8 9.414V32a1 1 0 001 1z",
    fill: "#97BA1E",
    stroke: "#97BA1E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17v12m4-8v8m4-4v4m4-1v1",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 21V11H12l10 10z",
    fill: "#F6F8FC",
    stroke: "#97BA1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 27v-7h-7l7 7z",
    fill: "#F6F8FC",
    stroke: "#97BA1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.113 12.427l.905 1.577h1.42l-1.534-2.447 1.525-2.4H28.03l-.857 1.591h-.079l-.857-1.59h-1.472l1.53 2.451-1.517 2.395h1.354l.9-1.577h.08zm3.173-2.83h1.23c0-.607.404-1.033 1.05-1.033.62 0 .98.4.98.905 0 .427-.171.716-.962 1.477l-2.224 2.127V14h4.575v-1.103H32.15v-.08l1.318-1.23c1.055-.988 1.38-1.498 1.38-2.24 0-1.073-.861-1.85-2.206-1.85-1.389 0-2.355.856-2.355 2.1z",
    fill: "#97BA1E"
  }));
};

exports.MealSandwichTwoFilled = MealSandwichTwoFilled;
var _default = MealSandwichTwoFilled;
exports.default = _default;